// Apps and API, webhooks, connected apps (specs 30).
const appsEn = {
  "apps.title": "Apps and API",
  "apps.nav_hint": "Custom apps, API tokens, connected apps and webhooks",
  "apps.description": "Connect your ERP, accounting, mobile app or headless storefront with the Admin API, the Storefront API and webhooks.",
  "apps.create": "Create custom app",
  "apps.edit": "Edit",
  "apps.done": "Done",
  "apps.empty": "Connect your own software",
  "apps.empty_body": "A custom app gets an access token for the Admin API with only the access you choose. Uninstall it any time to cut off its access.",
  "apps.kind.custom": "Custom app",
  "apps.kind.partner": "Connected app",
  "apps.status.active": "Installed",
  "apps.status.uninstalled": "Uninstalled",
  "apps.webhooks_count": "{count, plural, =0 {No webhooks} one {# webhook} other {# webhooks}}",
  "apps.scopes_count": "{count, plural, =0 {No access} one {# access scope} other {# access scopes}}",
  "apps.installed_on": "Installed {date}",
  "apps.developer": "Developer",
  "apps.developer_email": "Developer email",
  "apps.developer_email_hint": "We email this address when the app's webhooks fail and get turned off.",
  "apps.name": "App name",
  "apps.api_version": "API version",
  "apps.api_version_hint": "Webhook payloads and responses use this version. Versions are supported for at least 12 months.",
  "apps.version_current": "{name} (current)",
  "apps.version_sunset": "{name} (until {date})",
  "apps.access": "API access",
  "apps.access_hint": "Give only the access the app needs. Write access includes read access.",
  "apps.access.none": "No access",
  "apps.access.read": "Read",
  "apps.access.write": "Read and write",
  "apps.special": "Sensitive data",
  "apps.scopes_readonly": "A connected app's access is set by its developer. Reinstall the app to approve new access.",
  "apps.created": "App created",
  "apps.saved": "App saved",
  "apps.endpoints": "Endpoints",
  "apps.admin_api": "Admin API",
  "apps.storefront_api": "Storefront API",
  "apps.openapi": "OpenAPI document",
  "apps.docs": "API reference",
  "apps.endpoints_hint": "Send the admin token in the X-Sooquna-Access-Token header, and the storefront token in X-Sooquna-Storefront-Access-Token.",

  "apps.tokens": "Access tokens",
  "apps.tokens_hint": "Tokens call the API; they don't sign webhooks. The Admin API token can read and change your store: keep it on a server. The Storefront API token only reads published products and manages carts, so it's safe in a browser or mobile app.",
  "apps.token.admin": "Admin API",
  "apps.token.storefront": "Storefront API",
  "apps.token_revoked": "Revoked {date}",
  "apps.token_last_used": "Last used {date}",
  "apps.token_never_used": "Never used",
  "apps.rotate_admin": "Rotate admin token",
  "apps.rotate_admin_body": "A new token is created and the current one stops working right away. Update the app with the new token.",
  "apps.add_storefront": "Create storefront token",
  "apps.revoke": "Revoke",
  "apps.revoke_title": "Revoke this token?",
  "apps.revoke_body": "Requests with this token are refused right away. This can't be undone.",
  "apps.revoked": "Token revoked",
  "apps.token_title": "Copy the access token",
  "apps.token_once": "Copy it now and keep it somewhere safe. For your security, you won't see it again.",
  "apps.copied": "Copied",

  "apps.credentials": "Client credentials",
  "apps.credentials_hint": "The client secret signs the app's webhooks (X-Sooquna-Hmac-Sha256). Check the signature before trusting a webhook.",
  "apps.client_id": "Client ID",
  "apps.client_secret": "Client secret",
  "apps.reveal": "Reveal",
  "apps.rotate_secret": "Rotate secret",
  "apps.rotate_secret_body": "A new secret is created and signs webhooks from now on. Update the app before the next webhook arrives.",
  "apps.hidden": "Hidden",

  "apps.usage": "API requests, last 30 days",
  "apps.usage_requests": "Requests",
  "apps.usage_errors": "{count, plural, one {# failed request} other {# failed requests}} in 30 days",
  "apps.usage_none": "No requests yet.",

  "apps.uninstall": "Uninstall app",
  "apps.uninstall_title": "Uninstall {name}?",
  "apps.uninstall_body": "Its tokens stop working right away and its webhooks are turned off. The app gets one last app/uninstalled webhook.",
  "apps.uninstalled": "App uninstalled",
  "apps.uninstalled_banner": "This app was uninstalled {date}. Its tokens and webhooks no longer work.",

  "apps.scope.products": "Products",
  "apps.scope.inventory": "Inventory",
  "apps.scope.locations": "Locations",
  "apps.scope.customers": "Customers",
  "apps.scope.orders": "Orders",
  "apps.scope.draft_orders": "Draft orders",
  "apps.scope.fulfillments": "Fulfillments",
  "apps.scope.returns": "Returns",
  "apps.scope.discounts": "Discounts",
  "apps.scope.gift_cards": "Gift cards",
  "apps.scope.content": "Online store content",
  "apps.scope.themes": "Themes",
  "apps.scope.files": "Files",
  "apps.scope.markets": "Markets",
  "apps.scope.translations": "Translations",
  "apps.scope.reports": "Reports",
  "apps.scope.shipping": "Shipping",
  "apps.scope.metaobjects": "Custom data",
  "apps.scope.all_orders": "All orders",
  "apps.scope.customer_pii": "Customer contact details",
  "apps.scope_desc.products": "Products, variants, collections and the product taxonomy.",
  "apps.scope_desc.inventory": "Stock levels, adjustments, transfers, suppliers and purchase orders.",
  "apps.scope_desc.locations": "Warehouses, shops and pickup points.",
  "apps.scope_desc.customers": "Customers, their addresses and segments. Contact details need the customer contact details access.",
  "apps.scope_desc.orders": "Orders, transactions, refunds and abandoned checkouts from the last 60 days.",
  "apps.scope_desc.draft_orders": "Draft orders.",
  "apps.scope_desc.fulfillments": "Fulfillment orders, fulfillments, shipping labels and tracking.",
  "apps.scope_desc.returns": "Return requests.",
  "apps.scope_desc.discounts": "Discounts and discount codes.",
  "apps.scope_desc.gift_cards": "Gift cards and their balances.",
  "apps.scope_desc.content": "Pages, blogs, articles, menus, redirects and policies.",
  "apps.scope_desc.themes": "Themes and theme files.",
  "apps.scope_desc.files": "Files and uploads.",
  "apps.scope_desc.markets": "Markets and their currencies, languages and domains.",
  "apps.scope_desc.translations": "Languages and translated content.",
  "apps.scope_desc.reports": "Analytics reports.",
  "apps.scope_desc.shipping": "Shipping profiles, zones, rates, local delivery and pickup.",
  "apps.scope_desc.metaobjects": "Metafields, their definitions, and metaobjects.",
  "apps.scope_desc.all_orders": "Orders older than 60 days.",
  "apps.scope_desc.customer_pii": "Customers' names, emails, phone numbers and addresses.",

  "wh.title": "Webhooks",
  "wh.app_hint": "Send events to the app as they happen. Each request is signed with the app's client secret.",
  "wh.store_hint": "Send store events to your own systems as they happen. Each request is signed with the key below.",
  "wh.add": "Add webhook",
  "wh.edit": "Edit webhook",
  "wh.empty": "No webhooks yet.",
  "wh.topic": "Event",
  "wh.endpoint": "URL",
  "wh.endpoint_hint": "An https:// address on the public internet. It should answer within 5 seconds with a 2xx status.",
  "wh.fields": "Fields",
  "wh.fields_hint": "Only send these top-level fields, separated by commas. Leave empty to send everything.",
  "wh.namespaces": "Metafield namespaces",
  "wh.namespaces_hint": "Include metafields in these namespaces, separated by commas.",
  "wh.status.active": "Active",
  "wh.status.disabled": "Turned off",
  "wh.failing_since": "First failed {date}",
  "wh.disabled_hint": "Turned off {date} after failing for 48 hours. Fix the endpoint, then turn it back on.",
  "wh.enable": "Turn on",
  "wh.disable": "Turn off",
  "wh.test": "Send test",
  "wh.test_sent": "Test sent: {status}",
  "wh.test_failed": "Test failed: {error}",
  "wh.deliveries": "Recent deliveries",
  "wh.delete_title": "Delete this webhook?",
  "wh.delete_body": "Events stop being sent to {endpoint}.",
  "wh.deleted": "Webhook deleted",
  "wh.saved": "Webhook saved",
  "wh.of_app": "From {app}",
  "wh.log_empty": "No deliveries in the last 30 days.",
  "wh.log_hint": "Deliveries are kept for 30 days. Failed deliveries are retried for 48 hours.",
  "wh.attempt": "Attempt {n}",
  "wh.manual": "Manual",
  "wh.no_response": "No response",
  "wh.request": "Request",
  "wh.response": "Response",
  "wh.resend": "Resend",
  "wh.resent": "Resent: {status}",
  "wh.latency": "{ms} ms",

  "install.title": "Install app",
  "install.choose_store": "Choose the store to install the app on",
  "install.no_stores": "You don't manage any store where you can install apps.",
  "install.wants": "{name} wants to access your store",
  "install.by": "Developed by {email}",
  "install.access": "It will be able to:",
  "install.read": "View {resource}",
  "install.write": "View and change {resource}",
  "install.reinstall": "Already installed. Installing again updates its access.",
  "install.cancel": "Cancel",
  "install.install": "Install app",
  "install.invalid": "This install link isn't valid. Ask the app's developer for a new one.",
  "install.redirecting": "Installing… you'll go back to the app in a moment.",

  "papps.title": "Connected apps",
  "papps.hint": "Build apps that merchants install from your install link (OAuth). Each install gets its own access token.",
  "papps.pending": "Connected apps are available once your partner account is approved.",
  "papps.create": "Create app",
  "papps.edit": "Edit app",
  "papps.app_url": "App URL",
  "papps.redirect_urls": "Allowed redirect URLs",
  "papps.redirect_hint": "One https:// address per line. After the merchant installs, we send them to one of these with the authorization code.",
  "papps.installs": "{count, plural, =0 {No installs} one {# install} other {# installs}}",
  "papps.install_url": "Install link",
  "papps.secret_title": "Client secret",
  "papps.secret_once": "Copy it now. Your app exchanges authorization codes with the client ID and this secret at {url}.",
  "papps.rotate_secret": "Rotate secret",
  "papps.delete_title": "Delete {name}?",
  "papps.delete_body": "Its install link stops working. An app that stores still have installed can't be deleted.",
  "papps.deleted": "App deleted",

  "apps.hide": "Hide",
  "apps.view": "View",
  "apps.last_30": "Last 30 days",
  "apps.more": "More actions",
  "apps.token_admin_use": "Send it in the X-Sooquna-Access-Token header from your server. Never put it in a browser or mobile app.",
  "apps.token_storefront_use": "Send it in the X-Sooquna-Storefront-Access-Token header. It's safe in a browser or mobile app.",
  "apps.token_saved": "I've saved it",
  "apps.access_more": "{first} and {count, plural, one {# more} other {# more}}",
  "apps.list_sep": ", ",
  "apps.admin_access": "Admin API access",
  "apps.admin_api_hint": "Read and change store data from your server.",
  "apps.storefront_api_hint": "Published products, carts and customer accounts for headless storefronts and mobile apps.",
  "apps.openapi_hint": "Import into Postman, Insomnia or a code generator.",
  "apps.client_id_hint": "Identifies the app.",
  "apps.client_secret_hint": "Also this app's webhook signing key. Keep it on your server.",
  "apps.col.app": "App",
  "apps.col.access": "Access",
  "apps.col.webhooks": "Webhooks",
  "apps.col.installed": "Installed",
  "apps.col.status": "Status",
  "apps.col.token": "Token",
  "apps.col.created": "Created",
  "apps.col.last_used": "Last used",
  "apps.configure": "Configure access",
  "apps.create_action": "Create app",
  "apps.create_hint": "Custom apps are built for this store only, by you or a developer you trust. After creating the app, choose the access it gets.",
  "apps.details": "App details",
  "apps.granted": "{count, plural, one {# granted} other {# granted}}",
  "apps.name_hint": "Shown in the activity log next to everything the app does.",
  "apps.name_placeholder": "e.g. ERP sync",
  "apps.no_access": "No access yet",
  "apps.no_access_yet": "This app can't read or change anything yet. Choose what it can access.",
  "apps.no_tokens": "No active tokens.",
  "apps.secret_rotated": "Client secret rotated",
  "apps.special_hint": "Off unless the app really needs it. Each one is shown to you in the activity log.",
  "apps.stat.requests": "API requests",
  "apps.stat.failed": "Failed requests",
  "apps.stat.rate": "{pct}% of requests",
  "apps.stat.last_used": "Last used",
  "apps.stat.webhooks": "Webhooks",
  "apps.version_latest": "Latest version",
  "apps.version_until": "Supported until {date}",
  "apps.tab.overview": "Overview",
  "apps.tab.configuration": "Configuration",
  "apps.tab.credentials": "API credentials",
  "apps.tab.webhooks": "Webhooks",
  "apps.group.catalog": "Catalog",
  "apps.group.orders": "Orders and fulfillment",
  "apps.group.customers": "Customers",
  "apps.group.marketing": "Marketing",
  "apps.group.store": "Online store",
  "apps.group.analytics": "Analytics",
  "wh.actions": "Actions",
  "wh.advanced": "Advanced options",
  "wh.delivered": "Delivered",
  "wh.failed": "Failed",
  "wh.disabled_on": "Turned off {date}",
  "wh.empty_body": "Send events like new orders or stock changes to your own systems the moment they happen.",
  "wh.group.store": "Store",
  "wh.key_created_on": "Created {date}",
  "wh.key_rotated": "Signing key rotated",
  "wh.key_rotated_on": "Rotated {date}",
  "wh.rotate": "Rotate key",
  "wh.rotate_title": "Rotate the signing key?",
  "wh.rotate_body": "Every webhook from now on, including retries, is signed with the new key. Update your systems right away or they'll reject the webhooks.",
  "wh.search_topics": "Search events",
  "wh.status": "Status",
  "wh.status.failing": "Failing",
  "wh.topic_hint": "We send a webhook each time this happens.",
  "wh.verify_docs": "How to verify webhooks",
  "wh.version_hint": "Payloads use this API version.",
  "wh.t.app/uninstalled": "App uninstalled",
  "wh.t.shop/update": "Store details update",
  "wh.t.products/create": "Product creation",
  "wh.t.products/update": "Product update",
  "wh.t.products/delete": "Product deletion",
  "wh.t.collections/create": "Collection creation",
  "wh.t.collections/update": "Collection update",
  "wh.t.collections/delete": "Collection deletion",
  "wh.t.inventory_levels/update": "Inventory level update",
  "wh.t.inventory_items/update": "Inventory item update",
  "wh.t.locations/create": "Location creation",
  "wh.t.locations/update": "Location update",
  "wh.t.locations/delete": "Location deletion",
  "wh.t.customers/create": "Customer creation",
  "wh.t.customers/update": "Customer update",
  "wh.t.customers/delete": "Customer deletion",
  "wh.t.customers/redact": "Customer data erasure",
  "wh.t.customers/data_request": "Customer data request",
  "wh.t.orders/create": "Order creation",
  "wh.t.orders/updated": "Order update",
  "wh.t.orders/edited": "Order edit",
  "wh.t.orders/paid": "Order payment",
  "wh.t.orders/cancelled": "Order cancellation",
  "wh.t.orders/fulfilled": "Order fulfillment",
  "wh.t.orders/partially_fulfilled": "Order partial fulfillment",
  "wh.t.order_transactions/create": "Order transaction creation",
  "wh.t.refunds/create": "Refund creation",
  "wh.t.fulfillments/create": "Fulfillment creation",
  "wh.t.fulfillments/update": "Fulfillment update",
  "wh.t.fulfillment_events/create": "Tracking update",
  "wh.t.returns/request": "Return request",
  "wh.t.returns/update": "Return update",
  "wh.t.draft_orders/create": "Draft order creation",
  "wh.t.draft_orders/update": "Draft order update",
  "wh.t.draft_orders/delete": "Draft order deletion",
  "wh.t.checkouts/create": "Checkout creation",
  "wh.t.checkouts/update": "Checkout update",
  "wh.t.carts/update": "Cart update",
  "wh.t.discounts/create": "Discount creation",
  "wh.t.discounts/update": "Discount update",
  "wh.t.discounts/delete": "Discount deletion",
  "wh.t.gift_cards/create": "Gift card creation",
  "wh.t.gift_cards/update": "Gift card update",
  "wh.t.themes/publish": "Theme publication",
  "wh.t.themes/update": "Theme update",
  "wh.t.themes/delete": "Theme deletion",
  "wh.t.domains/create": "Domain creation",
  "wh.t.domains/update": "Domain update",
  "wh.t.domains/destroy": "Domain removal",
  "wh.key_title": "Webhook signing key",
  "wh.key_store_body": "Every webhook above is signed with this key. Use it to check the X-Sooquna-Hmac-Sha256 header of each request. It's only for checking webhooks: it isn't an API token and can't call the API.",
  "wh.key_app_body": "This app's webhooks are signed with its client secret, so the client secret is the key to check the X-Sooquna-Hmac-Sha256 header with. The access tokens don't sign webhooks.",
  "wh.key_partner_body": "Signed with {app}'s client secret, which only its developer holds. The app checks the signatures itself, so there's no key for you to set up.",
  "wh.key_rotate_in_credentials": "Rotate it in API credentials",
};

export default appsEn;
